export const useConvertTokensToGroups = (tokens: ParagraphTokens) => {
  // const filteredTokens = tokens.filter((token) => token.text !== "\n");

  const groups = tokens.reduce(
    (acc, token) => {
      if (token.text === "\u000b") {
        if (acc.currentGroup.length > 0) {
          acc.groups.push(acc.currentGroup);
          acc.currentGroup = [];
        }
      } else {
        acc.currentGroup.push(token);
      }
      return acc;
    },
    { groups: [] as ParagraphTokens[], currentGroup: [] as ParagraphTokens }
  );

  if (groups.currentGroup.length > 0) {
    groups.groups.push(groups.currentGroup);
  }

  return groups.groups.length > 0 ? groups.groups : [[]];
};
